import ol_style_Style from 'ol/style/Style';
import ol_style_Icon from 'ol/style/Icon';

export class MarkerStyle {
    constructor(src) {
        this.src = 'https://openlayers.org/en/latest/examples/data/icon.png';
        this.style = new ol_style_Style({
            image: new ol_style_Icon(/** @type {olx.style.IconOptions} */ ({
                src: this.src
            }))
        });
        this.selectStyleFunction = (feature) => {
            return new ol_style_Style({
                image: new ol_style_Icon({
                    anchor: [0.5, 0.96],
                    color: '#4271AE',
                    src: 'https://openlayers.org/en/latest/examples/data/dot.png'
                })
            });
        };
        this.src = src;
    }
}